import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["deviceIdOnUrl"];
import { getHistory } from 'quartz-routing/service';
import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
import { getTrackingClient } from './dependencies';
import { PROPERTIES_TO_SCRUB, UUID_URL_PARAM, MAX_UUID_LENGTH } from '../constants';
import { scrubEvents } from '../scrubEvents';
import { setUuidOnUrl } from '../deviceIdOnUrl';
export const getAnonymousTrackingClient = _ref => {
  let {
      deviceIdOnUrl = false
    } = _ref,
    user = _objectWithoutPropertiesLoose(_ref, _excluded);
  const client = getTrackingClient({
    storage: anonymousStorage,
    user,
    onSendEventsHook: events => scrubEvents(events, PROPERTIES_TO_SCRUB, '**********')
  });
  if (!deviceIdOnUrl) {
    return client;
  }
  return Object.assign({}, client, {
    getDeviceId: () => {
      const history = getHistory();
      const searchParams = new URLSearchParams(history.location.search);
      const uuidFromUrl = searchParams.get(UUID_URL_PARAM) || undefined;

      // Valid Device ID in URL — use it so identity stays stable across navigations.
      if (uuidFromUrl && uuidFromUrl.length <= MAX_UUID_LENGTH) {
        return uuidFromUrl;
      }

      // No Device ID in the URL — stamp it with ours to ensure downstream pages use it correctly.
      if (uuidFromUrl === undefined) {
        const deviceId = client.getDeviceId();
        setUuidOnUrl(deviceId, searchParams, history);
        return deviceId;
      }

      // Device ID present but implausibly long — leave URL untouched, use storage ID.
      return client.getDeviceId();
    }
  });
};